import { FETCH_ROLES } from '../actions/Types';

const initialState = {
  items: [],
  item: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ROLES:
      return {
        ...state,
        items: action.payload,
      };
    default:
      return state;
  }
}
